const globals = {
	floats: {
		left: 'float-left',
		right: 'float-right',
	},
	positions: {
		left: 'left-0',
		right: 'right-0',
		top: 'top-0',
		bottom: 'bottom-0',
	},
	aspectRatios: {
		auto: 'aspect-auto',
		'1/1': 'aspect-[1/1]',
		'16/9': 'aspect-[16/9]',
		'21/9': 'aspect-[21/9]',
		'4/3': 'aspect-[4/3]',
	},
	fontSizes: {
		sm: 'text-sm',
		base: 'text-base',
		md: 'text-md',
		lg: 'text-lg',
		xl: 'text-xl',
		'2xl': 'text-2xl',
		'3xl': 'text-3xl',
		'4xl': 'text-4xl',
		'5xl': 'text-5xl',
	},
	justifyContent: {
		normal: 'justify-normal',
		start: 'justify-start',
		end: 'justify-end',
		center: 'justify-center',
		between: 'justify-between',
		around: 'justify-around',
		evenly: 'justify-evenly',
		stretch: 'justify-stretch',
	},
};

const settings = {
	// add component settings here
	NkButton: {
		fixedClasses:
			'nk-button inline-flex items-center transition duration-300 ease-out font-semibold relative rounded no-underline rounded-full',
		sizes: {
			default: 'px-5 py-3 min-h-6 text-base',
		},
		variants: {
			link: 'nk-link !rounded-none border-b-2',
		},
	},
	NkCard: {
		variants: {
			imagePreview: {
				wrapper:
					'flex flex-col min-h-full h-full justify-between bg-neutral-surface flex flex-col rounded-md',
				body: 'flex flex-col gap-3 p-6 h-full',
				header: '',
				image: '',
				footer: 'mt-auto p-4 pt-0',
				link: 'transition duration-300 ease-out transform hover:-translate-y-1 hover:text-neutral-on-surface hover:bg-neutral-surface--active focus:text-neutral-on-surface focus:shadow-md focus:bg-neutral-surface--active',
			},
		},
	},
	NkFilterBrancheneintraegeRubriken: {
		variants: {
			default: {
				wrapper: '',
				form: '',
				categoryList: 'list-none border border-neutral-border',
				categoryItem: 'border-b border-neutral-border',
				categoryItemContainer: 'flex items-stretch min-h-6',
				categoryItemRow: 'flex flex-1 items-center px-2 last:py-2',
				categoryLabel: 'flex-1 truncate py-2 font-semibold cursor-pointer',
				subCategoryToggleButton:
					'block p-2 min-h-full border-l border-neutral-border',
				subCategory: 'px-2 py-2 list-none border-t border-neutral-border',
				subCategoryItem: 'flex items-center pl-3 hover:bg-primary-100 py-1',
				subCategoryLabel: 'truncate py-2 flex-1 cursor-pointer',
			},
		},
	},
	NkImage: {
		classes: {
			container:
				'block relative bg-neutral-surface w-full rounded-md overflow-hidden',
		},
	},
	Nav: {
		variants: {
			resources: {
				wrapper: 'border border-neutral-border rounded-md',
				item: 'border-b border-neutral-border',
				link: 'flex items-center flex-no-wrap p-3 text-primary-text hover:text-primary-text--hover transition duration-300 group no-underline',
				content: 'px-3 flex-1 overflow-hidden underline',
				title:
					'font-bold group-hover:text-primary-text--hover group-focus:text-primary-text--active transition duration-300 underline',
				text: ' truncate inline-block text-neutral-text',
				longtext: 'whitespace-normal',
				prependIcon: {
					icon: 'file',
					color: 'primary-500',
					size: 'xl',
					inline: false,
				},
				appendIcon: {
					icon: 'download',
					color: 'type',
					size: 'xl',
					inline: false,
				},
			},
		},
	},
	NkBreadcrumb: {
		classes: {
			wrapper: 'container mx-auto my-4 px-3',
			container: '',
			list: 'list-none truncate',
			item: "italic text-sm py-1 inline-flex items-center after:content-[''] after:mx-3 after:bg-neutral-300 after:inline-block after:w-px after:h-[1.5em] after:align-middle last:after:content-none after:font-['boxicons']",
			link: 'text-primary-text inline items-center link-active-exact:text-neutral-text',
			currentPage: 'inline items-center ',
			homeTitle: 'hidden sm:inline-block',
		},
		homeIcon: {
			variant: 'default',
			backgroundColor: false,
			color: 'inherit',
		},
	},
	NkDrilldown: {
		variants: {
			default: {
				menu: 'nk-drilldown rounded overflow-hidden',
				menuInner: 'list-none',
				menuItem: 'border-b border-neutral-border last:border-0',
				menuItemButton:
					'relative flex w-full py-4 text-primary-text hover:bg-neutral-surface-hover',
				menuItemButtonActive:
					'border-b border-neutral-border text-primary-text',
				menuItemIcon: 'no-underline before-no-underline',
				menuItemButtonIcon:
					'ml-auto no-underline absolute right-0 mr-3 transform transition-transform duration-300 ease-in-out ',
				menuItemButtonIconActive: 'rotate-180',
				menuItemLink:
					'flex py-3 link-active:bg-neutral-surface link-active:text-neutral-on-surface link-active-exact:bg-neutral-surface link-active-exact:text-neutral-on-surface group-[.is-submenu]:pl-6',
				menuItemLinkIcon: 'no-underline before-no-underline',
				submenu: 'group is-submenu',
			},
		},
	},
	NkBox: {
		variants: {
			sidebar: '',
		},
	},
	NkSidebar: {
		classes: {
			wrapper: 'xl:max-w-[480px] [&>*]:py-6  divide-y divide-neutral-border',
		},
	},
	NkMeta: {
		variants: {
			default: 'flex items-center font-semibold uppercase tracking-wide',
			normal: 'flex items-center',
		},
	},
	NkCarousel: {
		variants: {
			default: {
				sliderOptions: {
					spaceBetween: 16,
					slidesPerView: 1.25,
					centeredSlides: true,
					autoplay: {
						delay: 2500,
					},
					breakpoints: {
						640: {
							slidesPerView: 2,
							spaceBetween: 16,
							centeredSlides: false,
						},
						768: {
							slidesPerView: 2,
							spaceBetween: 24,
							centeredSlides: false,
						},
						1024: {
							slidesPerView: 3,
							spaceBetween: 24,
							centeredSlides: false,
						},
						1280: {
							slidesPerView: 3,
							spaceBetween: 24,
							centeredSlides: false,
						},
						1600: {
							slidesPerView: 4,
							spaceBetween: 24,
							centeredSlides: false,
						},
					},
				},
				wrapper: 'relative',
				slider: 'sm:overflow-hidden',
				sliderItem: 'flex items-center justify-center',
				slideContent: 'h-full w-full',
				slideBackgroundImage: '',
				slideBackgroundImageContainer: '',
				controls: 'flex justify-between items-center mt-4',
				buttonWrapper: 'flex gap-3',
				button:
					'transition ease-out rounded-full duration-300 justify-center items-center p-1 text-center bg-secondary-element hover:bg-secondary-element--hover text-secondary-on-element text-xl hover:text-secondary-on-element--hover focus:text-secondary-on-element--active hidden sm:inline-flex disabled:pointer-events-none',
				buttonLeft: 'left-0',
				buttonLeftIcon: 'arrow-left',
				buttonRight: 'right-0',
				buttonRightIcon: 'arrow-right',
				buttonDisabled: 'opacity-50 cursor-not-allowed',
				paginationWrapper: 'block mx-auto sm:mx-0',
				pagination: 'flex justify-center md:justify-start list-none -mx-1',
				paginationButton:
					'block w-8 is-active:w-10 h-3 mx-1 rounded bg-neutral-surface hover:bg-neutral-surface--active is-active:bg-secondary-element--active transition',
				paginationButtonActive: 'is-active',
			},
			hero: {
				sliderOptions: {
					spaceBetween: 0,
					slidesPerView: 1,
					speed: 600,
					centeredSlides: true,
					navigation: true,
					pagination: false,
					effect: 'fade',
					autoplay: {
						delay: 6000,
					},
					fadeEffect: {
						crossFade: true,
					},
				},
				wrapper: 'relative w-full bg-secondary-surface overflow-hidden',
				slider: 'h-full min-h-full',
				sliderItem:
					'flex items-center h-full aspect-[1/1] lg:aspect-[4/3] xl:aspect-[21/9] max-h-[90dvh]',
				slideContent: 'relative z-10 h-full w-full',
				slideBackgroundImage:
					'absolute top-0 left-0 h-full w-full object-cover',
				slideBackgroundImageContainer: 'absolute top-0 left-0 h-full w-full',
				controls: 'bg-primary-700 sm:bg-transparent',
				buttonWrapper:
					'flex gap-1 sm:absolute bottom-3 right-3 flex px-6 py-4 transform z-20',
				button:
					'transition ease-out rounded-full duration-300 justify-center items-center p-1 text-center bg-secondary-element hover:bg-secondary-element--hover text-secondary-on-element text-xl hover:text-secondary-on-element--hover focus:text-secondary-on-element--active inline-flex disabled:pointer-events-none',
				buttonLeft: '',
				buttonLeftIcon: 'chevron-left',
				buttonRight: '',
				buttonRightIcon: 'chevron-right',
				buttonDisabled: 'opacity-50 cursor-not-allowed pointer-events-none',
				paginationWrapper:
					'absolute w-full bottom-0 block z-10 my-6 translate-y-1/2 transform',
				pagination:
					'flex flex-wrap items-center list-none -mx-1 justify-center',
				paginationButton:
					'block w-8 is-active:w-10 h-3 mx-1 rounded bg-white/50 hover:bg-white/75 is-active:bg-white transition-all',
				paginationButtonActive: 'is-active',
			},
			'hero-slim': {
				sliderOptions: {
					spaceBetween: 0,
					slidesPerView: 1,
					speed: 600,
					centeredSlides: true,
					navigation: true,
					effect: 'fade',
					autoplay: {
						delay: 6000,
					},
					fadeEffect: {
						crossFade: true,
					},
				},
				wrapper: 'relative w-full bg-secondary-surface overflow-hidden',
				slider: 'h-full min-h-full',
				sliderItem:
					'flex items-center h-full aspect-[4/3] md:daspect-[16/9] lg:aspect-[21/9] max-h-[560px]',
				slideContent:
					'relative z-10 py-10 px-3 max-w-screen-sm mx-auto text-center text-shadow-sm flex h-full items-center justify-center',
				slideBackgroundImage:
					'absolute top-0 left-0 h-full w-full object-cover',
				slideBackgroundImageContainer: 'absolute top-0 left-0 h-full w-full',
				controls:
					'bg-primary-700 sm:bg-transparent flex flex-row-reverse items-center justify-between px-4',
				buttonWrapper:
					'flex gap-1 sm:absolute bottom-3 right-3 flex sm:px-6 py-4 transform z-20',
				button:
					'transition ease-out rounded-full duration-300 justify-center items-center p-1 text-center bg-secondary-element hover:bg-secondary-element--hover text-secondary-on-element text-xl hover:text-secondary-on-element--hover focus:text-secondary-on-element--active inline-flex disabled:pointer-events-none',
				buttonLeft: '',
				buttonLeftIcon: 'chevron-left',
				buttonRight: '',
				buttonRightIcon: 'chevron-right',
				buttonDisabled: 'opacity-50 cursor-not-allowed pointer-events-none',
				paginationWrapper:
					'sm:absolute sm:w-full bottom-0 block z-10 sm:my-6 sm:translate-y-1/2 transform',
				pagination:
					'flex flex-wrap items-center list-none -mx-1 justify-center',
				paginationButton:
					'block w-8 is-active:w-10 h-3 mx-1 rounded bg-white/50 hover:bg-white/75 is-active:bg-white transition-all',
				paginationButtonActive: 'is-active',
			},
		},
	},
	NkLink: {
		fixedClasses: '',
		classes: '',
	},
};

export {settings, globals};
